// extracted by mini-css-extract-plugin
module.exports = {"bar":"ModalTopBar_bar__3BCLm"};